import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'builds-detail-rdc';

export const rdcBuildsDetailV2Types = v2.buildsDetail.types.createRDCTypes(NAMESPACE);
export const rdcBuildsListV2Types = v2.buildsList.types.createRDCTypes(NAMESPACE);
